/* Turf Care Pro — category-first menu behaviour (5-10-2026). Hover intent, click/tap, keyboard. */
(function () {
  'use strict';
  var nav = document.querySelector('[data-tnv]');
  if (!nav) return;
  var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-tnv-tab]'));
  var openTab = null, tOpen = null, tClose = null;
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function panelOf(t) { return document.getElementById(t.getAttribute('aria-controls')); }
  function close() {
    if (!openTab) return;
    openTab.setAttribute('aria-expanded', 'false');
    var p = panelOf(openTab); if (p) p.classList.remove('is-open');
    openTab = null; document.body.classList.remove('tnv-open');
  }
  function open(t) {
    if (openTab === t) return;
    close();
    var p = panelOf(t); if (!p) return;
    t.setAttribute('aria-expanded', 'true'); p.classList.add('is-open');
    openTab = t; document.body.classList.add('tnv-open');
  }
  tabs.forEach(function (t, i) {
    var li = t.parentElement, p = panelOf(t);
    li.addEventListener('mouseenter', function () { if (coarse) return; clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { open(t); }, openTab ? 0 : 140); });
    li.addEventListener('mouseleave', function () { if (coarse) return; clearTimeout(tOpen); tClose = setTimeout(close, 220); });
    t.addEventListener('click', function (e) {
      /* touch screens: first tap opens the panel, the "View all" link inside goes to the page */
      if (coarse && openTab !== t) { e.preventDefault(); open(t); }
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(t); var f = p && p.querySelector('a'); if (f) f.focus(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); var n = tabs[(i + 1) % tabs.length]; n.focus(); if (openTab) open(n); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); var b = tabs[(i - 1 + tabs.length) % tabs.length]; b.focus(); if (openTab) open(b); }
      else if (e.key === 'Escape') { close(); }
    });
    if (p) p.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); t.focus(); } });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) { if (openTab === t) close(); } });
  });
  document.addEventListener('click', function (e) { if (openTab && !nav.contains(e.target)) close(); });
  window.addEventListener('scroll', function () { if (openTab && !coarse) { var r = nav.getBoundingClientRect(); if (r.bottom < 0) close(); } }, { passive: true });
})();
